// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2791261c","977":"8e6f169c"}[chunkId] + ".chunk.js";
};